// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__8Orh5","left":"styles_left__3VMD5","right":"styles_right__1BToj","alert":"styles_alert__1vBaH"};